import React from "react";
import "../user/ui/styles/RegisterForm.scss"

interface Props {
    children: any;
    style?: object;
    position?: string;
}

const FormContainer: React.FC<Props> = (props: Props) => {
    return (
        <div style={props.style} className={props.position === 'landing' ? "register-form-container landing" : "register-form-container"}>
            {
                props.children
            }
        </div>
    )
}

export default FormContainer;